var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-wrapper"},[_c('div',{staticClass:"calculator"},[_c('CalculatorHeading',{attrs:{"step":_vm.step}}),_c('SelectInput',{attrs:{"question":_vm.$t('expectations.question'),"selections":[
        {
          image: require('@/assets/warning.svg'),
          name: _vm.$t('expectations.one'),
          value: 'way-too-expensive'
        },
        {
          image: require('@/assets/empty-cart.svg'),
          name: _vm.$t('expectations.two'),
          value: 'a-bit-too-expensive'
        },
        {
          image: require('@/assets/order-confirmed.svg'),
          name: _vm.$t('expectations.three'),
          value: 'just-right'
        },
        {
          image: require('@/assets/deliveries.svg'),
          name: _vm.$t('expectations.four'),
          value: 'can-afford-more'
        },
        {
          image: require('@/assets/select-house.svg'),
          name: _vm.$t('expectations.five'),
          value: 'can-afford-everything'
        }
      ],"selected-value":_vm.expectations,"clicked-callback":_vm.onSelect}}),_c('a',{staticClass:"back-btn",on:{"click":function($event){_vm.$router.push(_vm.getPrevStepUrl(_vm.step))}}},[_vm._v(_vm._s(_vm.$t("back")))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }